export default {"src":"/_next/static/media/bold_filled.e22e2d38.svg","height":24,"width":24};